import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsAuthenticated, setToken } from "../store/slices/authSlice";
import {
  setUser,
  setPreferences,
  setDataSyncTime,
} from "../store/slices/userSlice";
import { GetUserData } from "../services/apiService/userApi";
import { Spinner } from "./ui/Skeleton";

const formatDate = (inputDate) => {
  const date = new Date(inputDate);
  const pad = (n) => n.toString().padStart(2, "0");

  return (
    `${pad(date.getMonth() + 1)}/${pad(
      date.getDate()
    )}/${date.getFullYear()} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`
  );
};

const SamlCallback = () => {
  const navigate = useNavigate();
  let dispatch = useDispatch();

  useEffect(() => {
    const handleSamlResponse = async () => {
      try {
        const response = await GetUserData();

        if (response?.data && response?.success) {
          const { userData, tokens, date } = response?.data;

          let dataSyncValue = {
            id: date.id,
            value: formatDate(date?.[0]?.date),
          };

          dispatch(setIsAuthenticated(true));
          dispatch(setToken(tokens));
          dispatch(setUser(userData));
          dispatch(setPreferences(userData?.preferences || []));
          dispatch(setDataSyncTime(dataSyncValue));
          navigate("/loading");
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.error("SAML login failed:", error);
        navigate("/login");
      }
    };

    handleSamlResponse();
  }, [navigate]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spinner />
    </div>
  );
};

export default SamlCallback;
